import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import Lib from '../../commons/lib';
import TeremberlesContent from './TeremberlesContent';
import CustomTooltip from '../../components/Tooltip/CustomTooltip';
import getTooltip from './TeremberlesTooltips';

class TeremberlesBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Terembérlés
              <CustomTooltip text={getTooltip('teremberles')} id="teremberlesTT" />
              {/* <YouTube data={videoData} /> */}
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <TeremberlesContent {...this.props} globals={this.props.globals} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TeremberlesBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default TeremberlesBase;
